import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './history-orders.actions';

const initialState: OLO.State.HistoryOrders = {
    isDownloading: false,
    hasSucceeded: false,
    hasFailed: false,
    isDownloadingMore: false,
    hasSucceededMore: false,
    hasFailedMore: false,
    downloadedDate: null,
    orders: [],
};

export const historyOrdersReducerFn = createReducer(
    initialState,
    on(actions.HistoryOrdersReset, () => ({
        isDownloading: false,
        hasSucceeded: false,
        hasFailed: false,
        isDownloadingMore: false,
        hasSucceededMore: false,
        hasFailedMore: false,
        downloadedDate: null,
        orders: [],
    })),
    on(actions.HistoryOrdersRequest, (state) => ({
        ...state,
        isDownloading: true,
        hasSucceeded: false,
        hasFailed: false,
    })),
    on(actions.HistoryOrdersSuccessRequest, (state, action) => {
        const mapIds = action.payload?.map((order) => order.AccessToken) || [];
        const oldToUpdate = [];
        const newToAdd = [];
        for (let i = 0, j = mapIds.length; i < j; i++) {
            if (state.orders.find((order) => order.orderGUID === mapIds[i])) {
                oldToUpdate.push(mapIds[i]);
            } else {
                newToAdd.push(mapIds[i]);
            }
        }

        return {
            ...state,
            isDownloading: false,
            hasSucceeded: true,
            hasFailed: false,
            downloadedDate: new Date().getTime(),
            orders: [
                ...state.orders.map((order) => {
                    if (oldToUpdate.includes(order.orderGUID)) {
                        return {
                            ...order,
                            data: action.payload.find((obj) => obj.AccessToken === order.orderGUID),
                            isDownloading: false,
                            hasSucceeded: true,
                            hasFailed: false,
                            downloadedDate: new Date().getTime(),
                            orderGUID: order.orderGUID,
                        };
                    }

                    return order;
                }),
                ...newToAdd.map((orderGUID) => ({
                    orderGUID: orderGUID,
                    isDownloading: false,
                    hasSucceeded: true,
                    hasFailed: false,
                    downloadedDate: new Date().getTime(),
                    data: action.payload.find((obj) => obj.AccessToken === orderGUID),
                })),
            ],
        };
    }),
    on(actions.HistoryOrdersErrorRequest, (state) => ({
        ...state,
        isDownloading: false,
        hasSucceeded: false,
        hasFailed: true,
    })),

    on(actions.HistoryOrdersLoadMoreRequest, (state) => ({
        ...state,
        isDownloadingMore: true,
        hasSucceededMore: false,
        hasFailedMore: false,
    })),
    on(actions.HistoryOrdersLoadMoreSuccessRequest, (state, action) => {
        const mapIds = action.payload.map((order) => order.AccessToken);
        const oldToUpdate = [];
        const newToAdd = [];
        for (let i = 0, j = mapIds.length; i < j; i++) {
            if (state.orders.find((order) => order.orderGUID === mapIds[i])) {
                oldToUpdate.push(mapIds[i]);
            } else {
                newToAdd.push(mapIds[i]);
            }
        }

        return {
            ...state,
            isDownloadingMore: false,
            hasSucceededMore: true,
            hasFailedMore: false,
            downloadedDate: new Date().getTime(),
            orders: [
                ...state.orders.map((order) => {
                    if (oldToUpdate.includes(order.orderGUID)) {
                        return {
                            ...order,
                            data: action.payload.find((obj) => obj.AccessToken === order.orderGUID),
                            isDownloading: false,
                            hasSucceeded: true,
                            hasFailed: false,
                            downloadedDate: new Date().getTime(),
                            orderGUID: order.orderGUID,
                        };
                    }

                    return order;
                }),
                ...newToAdd.map((orderGUID) => ({
                    orderGUID: orderGUID,
                    isDownloading: false,
                    hasSucceeded: true,
                    hasFailed: false,
                    downloadedDate: new Date().getTime(),
                    data: action.payload.find((obj) => obj.AccessToken === orderGUID),
                })),
            ],
        };
    }),
    on(actions.HistoryOrdersLoadMoreErrorRequest, (state) => ({
        ...state,
        isDownloadingMore: false,
        hasSucceededMore: false,
        hasFailedMore: true,
    })),

    /* Single */
    on(actions.HistoryOrderRequest, (state, action) => {
        const foundOrder: OLO.State.HistoryOrders.OnlineOrderItemObj = state.orders.find((order) => order.orderGUID === action.orderGUID);

        if (!foundOrder) {
            return {
                ...state,
                orders: [
                    ...state.orders,
                    {
                        orderGUID: action.orderGUID,
                        isDownloading: true,
                        hasSucceeded: false,
                        hasFailed: false,
                        downloadedDate: null,
                        data: null,
                    },
                ],
            };
        }

        return {
            ...state,
            orders: state.orders.map((order) => {
                if (order.orderGUID === action.orderGUID) {
                    return {
                        ...order,
                        isDownloading: true,
                        hasSucceeded: false,
                        hasFailed: false,
                    };
                }

                return order;
            }),
        };
    }),
    on(actions.HistoryOrderSuccessRequest, (state, action) => ({
        ...state,
        orders: state.orders.map((order) => {
            if (order.orderGUID === action.orderGUID) {
                return {
                    ...order,
                    isDownloading: false,
                    hasSucceeded: true,
                    hasFailed: false,
                    downloadedDate: new Date().getTime(),
                    data: action.payload,
                };
            }

            return order;
        }),
    })),
    on(actions.HistoryOrderErrorRequest, (state, action) => ({
        ...state,
        orders: state.orders.map((order) => {
            if (order.orderGUID === action.orderGUID) {
                return {
                    ...order,
                    isDownloading: false,
                    hasSucceeded: false,
                    hasFailed: true,
                };
            }

            return order;
        }),
    })),
);

export function historyOrdersReducer(state: OLO.State.HistoryOrders | undefined, action: Action) {
    return historyOrdersReducerFn(state, action);
}
